import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SIDEBARNAVIGATIONMODALPREPAYMENTACCOUNTITEMBLOCK_LEGACY_FIELD_ORDER = [
  "path",
  "shop_entity"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  sidebarNavigationModalPrepaymentAccountItemBlockDescriptor: _generatedSidebarNavigationModalPrepaymentAccountItemBlockDescriptor,
  sidebarNavigationModalPrepaymentAccountItemBlockBlocDefinition,
  sidebarNavigationModalPrepaymentAccountItemBlockDashboardLayout,
  sidebarNavigationModalPrepaymentAccountItemBlockConfig,
  sidebarNavigationModalPrepaymentAccountItemBlockResolveConfig,
  sidebarNavigationModalPrepaymentAccountItemBlockProperties,
} = doodBlockConfig(
  {
    name: "SidebarNavigationModalPrepaymentAccountItemBlock",
    componentType: 'SidebarNavigationModalPrepaymentAccountItemBlockComponent',
    category: 'navigation',
    description: "SidebarNavigationModalPrepaymentAccountItemBlock.",
    keywords: [],
    allowedIn: [
      { bloc: "SidebarNavigationModalComponent", slot: "custom_items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.sidebar-navigation-modal-prepayment-account-item.title.label",
      }
    }),
    path: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.sidebar-navigation-modal-prepayment-account-item.path.label",
        modes: [
          "page",
          "anchor"
        ]
      }
    }),
    shop_entity: propertyValue({
      type: 'shop_picker',
      value: '',
      options: {
        label: "pages.blocks.sidebar-navigation-modal-prepayment-account-item.shop-entity.label",
        max: 1
      }
    })
  }),

  () => ({
    omitFields: ["title"] as const,
    tabs: [
      {
        label: "pages.blocks.sidebar-navigation-modal-prepayment-account-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.sidebar-navigation-modal-prepayment-account-item.fieldset.link.label",
            fields: ["path"],
          },
          {
            legend: "pages.blocks.sidebar-navigation-modal-prepayment-account-item.fieldset.shop.label",
            fields: ["shop_entity"],
          },
        ],
      },
    ],
  })
);

export function sidebarNavigationModalPrepaymentAccountItemBlockDescriptor(): IBlockDescriptor;
export function sidebarNavigationModalPrepaymentAccountItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function sidebarNavigationModalPrepaymentAccountItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedSidebarNavigationModalPrepaymentAccountItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedSidebarNavigationModalPrepaymentAccountItemBlockDescriptor, sidebarNavigationModalPrepaymentAccountItemBlockProperties, fieldOrder);
}

export {
  sidebarNavigationModalPrepaymentAccountItemBlockBlocDefinition,
  sidebarNavigationModalPrepaymentAccountItemBlockDashboardLayout,
  sidebarNavigationModalPrepaymentAccountItemBlockProperties,
  sidebarNavigationModalPrepaymentAccountItemBlockConfig,
  sidebarNavigationModalPrepaymentAccountItemBlockResolveConfig,
};

export type SidebarNavigationModalPrepaymentAccountItemBlockConfig = typeof sidebarNavigationModalPrepaymentAccountItemBlockConfig;
